import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';
import { CardType, COBRAND_CARD_TYPE } from '../constants';
import { hasSelectedCardsChanged } from '../utils';

type CardItem = {
  cardType?: CardType;
  cardname?: string;
  imagePath?: string;
  header?: string;
  checked?: boolean;
};

type CobrandData = {
  activeTabValue?: CardType;
  selectedCards: CardItem[];
  allCarouselCards: CardItem[];
};

export type CobrandStore = {
  cobrandData: CobrandData;
  compareTrayAlertVisible: boolean;
  setCobrandData: (data: CobrandData) => void;
  setCompareTrayAlertVisible: (visible: boolean) => void;
};

const initialState: CobrandStore = {
  cobrandData: {
    activeTabValue: COBRAND_CARD_TYPE.PERSONAL,
    selectedCards: [],
    allCarouselCards: [],
  },
  compareTrayAlertVisible: false,
  setCobrandData: () => null,
  setCompareTrayAlertVisible: () => null,
};

const CobrandStore: StateCreator<CobrandStore> = set => {
  return {
    ...initialState,
    setCobrandData: data => {
      set(state => {
        const selectedCardsChanged = hasSelectedCardsChanged(state.cobrandData.selectedCards, data.selectedCards);

        return {
          cobrandData: { ...data },
          compareTrayAlertVisible: selectedCardsChanged ? false : state.compareTrayAlertVisible,
        };
      });
    },
    setCompareTrayAlertVisible: visible => set({ compareTrayAlertVisible: visible }),
  };
};

export const useStore = createAppStore(CobrandStore, {
  usePersistentStore: false,
});
